<template>
  <div>
    <div
      v-if="isListMode"
      class="card"
    >
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="card-title mb-0">
          Aprovar/Reprovar Ajustes
        </div>
        <router-link
          to="/check-adjustment-requests"
          class="btn btn-secondary"
        >
          Voltar
        </router-link>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-3 mb-2 mb-md-0">
            <label>Status</label>
            <select
              v-model="filters.status"
              class="form-control"
            >
              <option value="">
                Todos
              </option>
              <option value="1">
                Pendente
              </option>
              <option value="2">
                Aprovado
              </option>
              <option value="3">
                Rejeitado
              </option>
            </select>
          </div>
          <div class="col-md-3 mb-2 mb-md-0">
            <label>Data solicitada</label>
            <input
              v-model="filters.date"
              type="date"
              class="form-control"
            >
          </div>
          <div class="col-md-4 mb-2 mb-md-0">
            <label>Usuário</label>
            <v-select
              v-model="filters.user"
              :options="users"
              label="name"
              :reduce="user => user.id"
              placeholder="Selecione um usuário"
              :disabled="loadingUsers || loadingList"
            />
          </div>
          <div class="col-md-2 d-flex align-items-end justify-content-md-end">
            <button
              class="btn btn-primary mr-2"
              :disabled="loadingList"
              @click="applyFilters"
            >
              Filtrar
            </button>
            <button
              class="btn btn-outline-secondary"
              :disabled="loadingList"
              @click="resetFilters"
            >
              Limpar
            </button>
          </div>
        </div>

        <div
          v-if="loadingList"
          class="text-center py-4"
        >
          Carregando...
        </div>
        <div v-else>
          <div
            v-if="!requests.length"
            class="alert alert-light border mb-0"
          >
            Nenhum ajuste encontrado para os filtros informados.
          </div>
          <div
            v-else
            class="table-responsive"
          >
            <table class="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Usuário</th>
                  <th>Solicitante</th>
                  <th>Horário antigo</th>
                  <th>Novo horário</th>
                  <th>Status</th>
                  <th class="text-right">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in requests"
                  :key="item.id"
                >
                  <td>{{ item.id }}</td>
                  <td>{{ resolveUserName(item) }}</td>
                  <td>{{ resolveRequesterName(item) }}</td>
                  <td>{{ resolveOldTime(item) }}</td>
                  <td>{{ resolveNewTime(item) }}</td>
                  <td>{{ statusLabel(item.status) }}</td>
                  <td class="text-right">
                    <button
                      class="btn btn-sm"
                      :class="Number(item.status) === 1 ? 'btn-info' : 'btn-outline-secondary'"
                      @click="openAnalysis(item)"
                    >
                      {{ Number(item.status) === 1 ? 'Analisar' : 'Visualizar' }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="pagination.total"
            class="d-flex justify-content-between align-items-center mt-3"
          >
            <div class="text-muted small">
              Mostrando {{ pagination.from || 0 }} até {{ pagination.to || 0 }} de {{ pagination.total }} registros
            </div>
            <div class="d-flex align-items-center">
              <select
                v-model.number="pagination.perPage"
                class="form-control mr-2"
                style="width: 90px;"
                @change="changePerPage"
              >
                <option :value="10">
                  10
                </option>
                <option :value="25">
                  25
                </option>
                <option :value="50">
                  50
                </option>
                <option :value="100">
                  100
                </option>
              </select>
              <button
                class="btn btn-outline-secondary btn-sm mr-2"
                :disabled="loadingList || pagination.currentPage <= 1"
                @click="changePage(pagination.currentPage - 1)"
              >
                Anterior
              </button>
              <span class="small text-muted mr-2">Página {{ pagination.currentPage }} de {{ pagination.lastPage || 1 }}</span>
              <button
                class="btn btn-outline-secondary btn-sm"
                :disabled="loadingList || pagination.currentPage >= pagination.lastPage"
                @click="changePage(pagination.currentPage + 1)"
              >
                Próxima
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="check-adjustment-analysis-modal"
      v-model="showAnalysisModal"
      size="lg"
      hide-footer
      title="Análise do ajuste"
    >
      <div v-if="selectedRequest">
        <div class="row mb-3">
          <div class="col-md-6">
            <label>Usuário</label>
            <div class="form-control-plaintext">
              {{ resolveUserName(selectedRequest) }}
            </div>
          </div>
          <div class="col-md-6">
            <label>Solicitante</label>
            <div class="form-control-plaintext">
              {{ resolveRequesterName(selectedRequest) }}
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Horário antigo</label>
            <div class="form-control-plaintext">
              {{ resolveOldTime(selectedRequest) }}
            </div>
          </div>
          <div class="col-md-4">
            <label>Novo horário</label>
            <div class="form-control-plaintext">
              {{ resolveNewTime(selectedRequest) }}
            </div>
          </div>
          <div class="col-md-4">
            <label>Status</label>
            <div class="form-control-plaintext">
              {{ statusLabel(selectedRequest.status) }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Justificativa do solicitante</label>
          <div class="form-control-plaintext">
            {{ selectedRequest.reason || '-' }}
          </div>
        </div>
        <div class="form-group">
          <label>Observação do aprovador</label>
          <textarea
            v-model="approverNote"
            class="form-control"
            rows="3"
            :disabled="Number(selectedRequest.status) !== 1"
          />
        </div>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-secondary mr-2"
            @click="closeAnalysis"
          >
            Fechar
          </button>
          <button
            v-if="canApprove && Number(selectedRequest.status) === 1"
            class="btn btn-danger mr-2"
            :disabled="processingId === selectedRequest.id"
            @click="rejectItem(selectedRequest, true)"
          >
            Reprovar
          </button>
          <button
            v-if="canApprove && Number(selectedRequest.status) === 1"
            class="btn btn-success"
            :disabled="processingId === selectedRequest.id"
            @click="approveItem(selectedRequest, true)"
          >
            Aprovar
          </button>
        </div>
      </div>
    </b-modal>

    <div
      v-if="!isListMode && request"
      class="card"
    >
      <div class="card-header">
        <div class="card-title">
          Analisar ajuste #{{ request.id }}
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Usuário</label>
            <div class="form-control-plaintext">
              {{ displayUserName }}
            </div>
          </div>
          <div class="col-md-4">
            <label>Horário antigo</label>
            <div class="form-control-plaintext">
              {{ displayOldTime }}
            </div>
          </div>
          <div class="col-md-4">
            <label>Novo horário solicitado</label>
            <div class="form-control-plaintext">
              {{ displayNewTime }}
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Solicitante</label>
            <div class="form-control-plaintext">
              {{ displayRequesterName }}
            </div>
          </div>
          <div class="col-md-4">
            <label>Status</label>
            <div class="form-control-plaintext">
              {{ statusLabel(request.status) }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Justificativa do solicitante</label>
          <div class="form-control-plaintext">
            {{ request.reason }}
          </div>
        </div>
        <div class="form-group">
          <label>Observação do aprovador</label>
          <textarea
            v-model="approverNote"
            class="form-control"
            rows="3"
            :disabled="request.status !== 1"
          />
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end">
        <router-link
          :to="{ name: 'approve-check-adjustment-requests' }"
          class="btn btn-secondary mr-2"
        >
          Voltar
        </router-link>
        <button
          v-if="canApprove"
          class="btn btn-danger mr-2"
          :disabled="saving || request.status !== 1"
          @click="reject"
        >
          Rejeitar
        </button>
        <button
          v-if="canApprove"
          class="btn btn-success"
          :disabled="saving || request.status !== 1"
          @click="approve"
        >
          Aprovar
        </button>
      </div>
    </div>

    <div
      v-if="!isListMode && !request"
      class="card"
    >
      <div
        v-if="!loadError"
        class="card-body text-center"
      >
        Carregando...
      </div>
      <div
        v-else
        class="card-body text-center text-danger"
      >
        {{ loadError }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  props: ['id'],
  data() {
    return {
      users: [],
      requests: [],
      request: null,
      selectedRequest: null,
      showAnalysisModal: false,
      filters: {
        status: '1',
        date: '',
        user: null,
      },
      loadingUsers: false,
      loadingList: false,
      processingId: null,
      pagination: {
        currentPage: 1,
        lastPage: 1,
        perPage: 10,
        total: 0,
        from: 0,
        to: 0,
      },
      approverNote: '',
      saving: false,
      loadError: '',
    }
  },
  computed: {
    isListMode() {
      return !this.$route.params.id && !this.id
    },
    isAdminRole() {
      return parseInt(localStorage.getItem('is_admin'), 10) || 0
    },
    canApprove() {
      const role = this.isAdminRole
      return role === 1 || role === 2 || role === 4
    },
    displayUserName() {
      const req = this.request || {}
      return (req.check && req.check.user && req.check.user.name) || '-'
    },
    displayOldTime() {
      const req = this.request || {}
      const change = (req.changes && req.changes.length) ? req.changes[0] : null
      return this.formatDate(change ? change.old_created_at : (req.check && req.check.created_at))
    },
    displayNewTime() {
      const req = this.request || {}
      const change = (req.changes && req.changes.length) ? req.changes[0] : null
      return this.formatDate(change ? change.new_created_at : req.requested_created_at)
    },
    displayRequesterName() {
      const req = this.request || {}
      return (req.requestedBy && req.requestedBy.name)
				|| (req.requested_by && req.requested_by.name)
				|| (req.requested_by_name)
				|| '-'
    },
  },
  mounted() {
    if (this.isListMode) {
      this.fetchUsers()
      this.fetchList()
      return
    }

    this.fetch()
  },
  methods: {
    resolveUserName(item) {
      return (item && item.check && item.check.user && item.check.user.name) || '-'
    },
    resolveRequesterName(item) {
      return (item && item.requestedBy && item.requestedBy.name)
				|| (item && item.requested_by && item.requested_by.name)
				|| (item && item.requested_by_name)
				|| '-'
    },
    resolveOldTime(item) {
      const change = item && item.changes && item.changes.length ? item.changes[0] : null
      return this.formatDate(change ? change.old_created_at : (item && item.check && item.check.created_at))
    },
    resolveNewTime(item) {
      const change = item && item.changes && item.changes.length ? item.changes[0] : null
      return this.formatDate(change ? change.new_created_at : item && item.requested_created_at)
    },
    statusLabel(id) {
      if (id === 1) return 'Pendente'
      if (id === 2) return 'Aprovado'
      if (id === 3) return 'Rejeitado'
      return 'Pendente'
    },
    formatDate(dt) {
      if (!dt) return '-'
      const m = moment(dt)
      return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : dt
    },
    async fetchUsers() {
      this.loadingUsers = true
      try {
        const api = `${this.$store.state.api}users/active`
        const res = await axios.get(api)
        this.users = Array.isArray(res.data) ? res.data : []
      } catch (e) {
        this.users = []
        this.$message('Erro', 'Não foi possível carregar usuários', 'error')
      } finally {
        this.loadingUsers = false
      }
    },
    applyFilters() {
      this.fetchList(1)
    },
    resetFilters() {
      this.filters = {
        status: '1',
        date: '',
        user: null,
      }
      this.fetchList(1)
    },
    changePage(page) {
      this.fetchList(page)
    },
    changePerPage() {
      this.fetchList(1)
    },
    async fetchList(page = this.pagination.currentPage || 1) {
      if (!this.canApprove) {
        this.loadError = 'Você não tem permissão para aprovar ajustes.'
        return
      }

      this.loadingList = true
      try {
        const params = {
          with: ['check', 'check.user', 'requestedBy', 'changes'],
          paginated: true,
          page,
          per_page: this.pagination.perPage,
        }

        if (this.filters.status !== '') {
          params.status = this.filters.status
        }

        if (this.filters.date) {
          params.date = this.filters.date
        }

        if (this.filters.user) {
          params.user_id = this.filters.user
        }

        const api = `${this.$store.state.api}check-adjustment-requests`
        const res = await axios.get(api, { params })
        const payload = res.data && typeof res.data === 'object' ? res.data : {}
        const items = Array.isArray(payload.data) ? payload.data : []
        this.requests = items.map(item => {
          if (!item.requestedBy && item.requested_by) {
            item.requestedBy = item.requested_by
          }
          return item
        })
        this.pagination.currentPage = payload.current_page || 1
        this.pagination.lastPage = payload.last_page || 1
        this.pagination.total = payload.total || 0
        this.pagination.from = payload.from || 0
        this.pagination.to = payload.to || 0
        this.loadError = ''
      } catch (e) {
        this.requests = []
        this.loadError = 'Não foi possível carregar os ajustes.'
        this.$message('Erro', this.loadError, 'error')
      } finally {
        this.loadingList = false
      }
    },
    async fetch() {
      try {
        const api = `${this.$store.state.api}check-adjustment-requests/${this.$route.params.id || this.id}`
        const res = await axios.get(api, { params: { with: ['check', 'check.user', 'requestedBy', 'changes'] } })
        const payload = res.data && typeof res.data === 'object' ? res.data : null
        let parsed = null
        if (payload) {
          const dataField = payload.data !== undefined ? payload.data : payload
          parsed = Array.isArray(dataField) ? dataField[0] : dataField
        }

        if (!parsed || !parsed.id) {
          this.loadError = 'Solicitação não encontrada.'
          this.request = null
          return
        }

        // normaliza para aceitar requested_by além de requestedBy
        if (!parsed.requestedBy && parsed.requested_by) {
          parsed.requestedBy = parsed.requested_by
        }
        this.request = parsed
        this.loadError = ''
      } catch (e) {
        this.loadError = 'Não foi possível carregar a solicitação'
        this.$message('Erro', this.loadError, 'error')
      }
    },
    async openAnalysis(item) {
      if (!item || !item.id) {
        return
      }

      this.processingId = item.id
      try {
        const api = `${this.$store.state.api}check-adjustment-requests/${item.id}`
        const res = await axios.get(api, { params: { with: ['check', 'check.user', 'requestedBy', 'changes'] } })
        const payload = res.data && typeof res.data === 'object' ? res.data : null
        const dataField = payload && payload.data !== undefined ? payload.data : payload
        const parsed = Array.isArray(dataField) ? dataField[0] : dataField
        if (!parsed || !parsed.id) {
          this.$message('Erro', 'Solicitação não encontrada', 'error')
          return
        }

        if (!parsed.requestedBy && parsed.requested_by) {
          parsed.requestedBy = parsed.requested_by
        }

        this.selectedRequest = parsed
        this.approverNote = parsed.approver_note || ''
        this.showAnalysisModal = true
      } catch (e) {
        this.$message('Erro', 'Não foi possível carregar a análise', 'error')
      } finally {
        this.processingId = null
      }
    },
    closeAnalysis() {
      this.showAnalysisModal = false
      this.selectedRequest = null
      this.approverNote = ''
    },
    async approveItem(item, closeModal = false) {
      if (!item || !item.id || Number(item.status) !== 1) {
        return
      }

      this.processingId = item.id
      const api = `${this.$store.state.api}check-adjustment-requests/${item.id}/approve`
      try {
        await axios.post(api, { approver_note: this.approverNote || null })
        this.$message('Sucesso', 'Ajuste aprovado', 'success')
        if (closeModal) {
          this.closeAnalysis()
        }
        this.fetchList(this.pagination.currentPage)
      } catch (e) {
        this.$message('Erro', 'Falha ao aprovar', 'error')
      } finally {
        this.processingId = null
      }
    },
    async rejectItem(item, closeModal = false) {
      if (!item || !item.id || Number(item.status) !== 1) {
        return
      }

      this.processingId = item.id
      const api = `${this.$store.state.api}check-adjustment-requests/${item.id}/reject`
      try {
        await axios.post(api, { approver_note: this.approverNote || null })
        this.$message('Sucesso', 'Ajuste rejeitado', 'success')
        if (closeModal) {
          this.closeAnalysis()
        }
        this.fetchList(this.pagination.currentPage)
      } catch (e) {
        this.$message('Erro', 'Falha ao rejeitar', 'error')
      } finally {
        this.processingId = null
      }
    },
    async approve() {
      if (!this.canApprove) {
        this.$message('Erro', 'Você não tem permissão para aprovar', 'error')
        return
      }
      this.saving = true
      const api = `${this.$store.state.api}check-adjustment-requests/${this.request.id}/approve`
      try {
        await axios.post(api, { approver_note: this.approverNote })
        this.$message('Sucesso', 'Ajuste aprovado', 'success')
        this.fetch()
      } catch (e) {
        this.$message('Erro', 'Falha ao aprovar', 'error')
      } finally {
        this.saving = false
      }
    },
    async reject() {
      if (!this.canApprove) {
        this.$message('Erro', 'Você não tem permissão para rejeitar', 'error')
        return
      }
      this.saving = true
      const api = `${this.$store.state.api}check-adjustment-requests/${this.request.id}/reject`
      try {
        await axios.post(api, { approver_note: this.approverNote })
        this.$message('Sucesso', 'Ajuste rejeitado', 'success')
        this.fetch()
      } catch (e) {
        this.$message('Erro', 'Falha ao rejeitar', 'error')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
